import { Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID } from '@angular/core';
import { OfferCardDataPrice } from 'projects/common/components/offers/offer-card-data.model';
import { CurrenciesContainer, Currency } from 'projects/common/model/landingModel';
import { AlertsComponent, AlertsService } from '@shopping-angular-components/alerts';
import { isPlatformBrowser } from '@angular/common';
import { UserFavoriteCardData, UserFavoriteTracker, FavoriteProductEnum } from '../../../user-favorite-data.model';
import { FavoriteSocialService } from '../../../favorite-social.service';
import { FlightsService } from 'projects/common/services/flights.service';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { UpaTarget } from 'projects/common/services/upa.service';

@Component({
  selector: 'favorite-card-pricebox',
  template: `
      <div *ngIf="price" class="{{ data.product.toLowerCase() }} offer-card-pricebox favorite-card-pricebox">
        <div class="offer-card-pricebox-price-wrapper">

          <div *ngIf="showPriceMessage" class="offer-card-pricebox-description">{{price.message}}</div>

          <div class="offer-card-pricebox-price">
            <div class="offer-card-pricebox-price-current">
              <span class="offer-card-pricebox-price-currency -eva-3-mr-xsm">{{currency.symbol}}</span>
              <span class="favorite-card-pricebox-price-amount">{{mainPrice}}</span>
            </div>
            <span class="favorite-card-pricebox-price-old" *ngIf="oldPrice">
              {{currency.symbol}} {{oldPrice}}
            </span>
          </div>

          <div class="bottom-price-message">
            <div *ngIf="price.price_per_days_message" class="offer-card-pricebox-description tax-message">{{price.price_per_days_message}}</div>
            <span *ngIf="secondaryPrice" class="offer-card-pricebox-description tax-message bold">{{currency.symbol}}{{secondaryPrice}}</span>
          </div>

          <div *ngIf="price.tax_message" class="offer-card-pricebox-description tax-message">{{price.tax_message}}</div>

        </div>

        <div class="cta-and-ribbon-wrapper" >

          <div class="offer-card-pricebox-label eva-3-label -md -top-right"
            *ngIf="price.promo?.ribbon"
            [ngClass]="price.promo.promo_type === 'LOGGED_IN' ? '-secret-deals' : price.promo.promo_type === 'IFOOD' ? '-ifood' : '-green'">
            <span class="label-container">
              <span class="-eva-3-bold label-text">
                <i *ngIf="price.promo.promo_type === 'LOGGED_IN'"
                  class="eva-3-icon-gift  label-icon -eva-3-tc-red-3"></i>
                {{this.price.promo.ribbon}}
              </span>
            </span>
          </div>

          <div *ngIf="data.product === 'FLIGHT' && showAlertBtn && !price.promo?.ribbon" class="cta-button-container" >

              <button name="" type="button" class="eva-3-btn -md -link" (click)="handleClickCTAFlight($event)">
                  <em class="btn-text">{{ 'userFavorites.flightCta' | translate }}</em>
                  <i class="eva-3-icon-chevron-right btn-icon"></i>
              </button>
          </div>
        </div>

      </div>
  `,
  styleUrls: ['./favorite-card-pricebox.component.scss'],
})
export class FavoriteCardPriceboxComponent implements OnInit, OnChanges{

  @Input() data: UserFavoriteCardData;
  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() moduleIndex: number;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() isWhiteLabel: boolean;
  @Input() showAlertBtn: boolean;
  @Input() showPriceMessage = true;
  @Input() nextFlow: string;

  price: OfferCardDataPrice;
  alertWasCreated: boolean;
  mainPrice: string | undefined;
  secondaryPrice: string | undefined;
  oldPrice: string | undefined;
  currencies: CurrenciesContainer;

  constructor( @Inject(PLATFORM_ID) private platformId: string,
              private alertsService: AlertsService,
              private favoriteSocialService: FavoriteSocialService,
              private flightsService: FlightsService,
              private landingModelService: LandingModelService) {

    AlertsComponent.favsEvent.subscribe((alertStatusOk: boolean) => {
      // Revisar cuando se arreglen las alertas de SAC
      // if (alertStatusOk) {
      //   console.log("alert created ok");
      // }else {
      //     console.log("alert created fail");
      // }
    });
  }

  ngOnInit(): void {
    this.currencies = this.landingModelService.getLandingModel().currencies;
    this.initPrice();
    this.setPriceContentByProduct();

    if (isPlatformBrowser(this.platformId)) {
      this.alertWasCreated = this.favoriteSocialService.alertsWasClicked(this.data.id);
    }
  }

  ngOnChanges(): void {
    this.currencies = this.landingModelService.getLandingModel().currencies;
    this.initPrice();
  }

  private setPriceContentByProduct() {
    switch (this.data.product) {
      case FavoriteProductEnum.CAR:
        this.mainPrice = this.price.promo?.real_price || this.price.per_day;
        this.oldPrice = this.price.promo && this.price.per_day;
        this.secondaryPrice = this.price.total_amount;
        break;
      case FavoriteProductEnum.TRANSFER:
        this.mainPrice = this.price.promo?.real_price || this.price.total_amount;
        this.oldPrice = this.price.promo && this.price.total_amount;
        break;
      default:
        this.mainPrice = this.price.total_amount;
        this.oldPrice = this.price.promo?.real_price;
        break;
    }
}

  private initPrice(): void {
    const priceFrom = this.data.offer_alternatives ? this.data.offer_alternatives[0] : this.data;

    this.price = priceFrom.price[this.currency.code];

    if (!this.price) {
      const availableCurrencyCode = Object.keys(priceFrom.price)[0];
      const foundCurrency = [this.currencies.primaryCurrency, this.currencies?.secondaryCurrency].find(currency => currency && currency.code === availableCurrencyCode);
      if (foundCurrency) {
        this.currency = foundCurrency;
        this.price = priceFrom.price[this.currency.code];
      }
    }
  }

  handleClickAlert(): void {
    if (!this.alertWasCreated) {
        this.favoriteSocialService.sendTracker(this.moduleId, this.uniqueId, this.moduleIndex, this.data.product, UserFavoriteTracker.CREATE_ALERT, UpaTarget.ALERT);
        localStorage.setItem('clusterFavsSelected', JSON.stringify(this.data));
        this.alertsService.createAlertFav(this.locale);
    }
  }


  handleClickCTAFlight(event): void {
    event.stopPropagation();
    if (this.nextFlow === 'CHECKOUT' || this.nextFlow === 'MODAL_SEARCH') {
      this.flightsService.showDistributionPassengersModal(this.moduleId, this.moduleIndex, this.locale, this.data, this.nextFlow);
    } else {
      const link: string = this.data.link.url;
      window.open(link, '_blank');
    }
    this.favoriteSocialService.sendTracker(this.moduleId, this.uniqueId, this.moduleIndex, this.data.product, UserFavoriteTracker.OPEN, UpaTarget.OFFER);
  }
}
